// Angular Files
import { NgModule } from '@angular/core';

// Teller Online Component Files
import { TellerOnlineDialogModule } from './dialog/dialog.component';
import { TellerOnlineFabMenuModule } from './fab-menu/fab-menu.component';
import { TellerOnlineNotificationModule } from './notification/notification.component';
import { PublicPortalComponentsModule } from './public/public-portal-components.module';
import { EditControlsModule } from './edit-controls/edit-controls.module';
import { TellerOnlineScheduleDetailsModule } from './schedule-details/schedule-details.module';

@NgModule({
    imports: [
        TellerOnlineFabMenuModule,
        TellerOnlineDialogModule,
        TellerOnlineNotificationModule,
        PublicPortalComponentsModule,
        EditControlsModule,
        TellerOnlineScheduleDetailsModule
    ],
    exports: [
        TellerOnlineFabMenuModule,
        TellerOnlineDialogModule,
        TellerOnlineNotificationModule,
        PublicPortalComponentsModule,
        EditControlsModule,
        TellerOnlineScheduleDetailsModule
    ]
})
export class ComponentsModule { }